module.exports = __webpack_public_path__ + "img/banner.05a1abcc.png";